import { css } from '@emotion/react';
import { theme } from '../../../theme';

const { primary, background } = theme.palette;
const { shadows } = theme;
const { md } = theme.breakpoints;

const tallestStyle = css`
  display: flex;
  position: absolute;
  visibility: hidden;

  & > div {
    position: relative;
  }
`;

const slideshowWrapper = css`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  padding: 50px 0 35px;
  display: flex;
  align-items: center;
`;

const slideshowSlide = css`
  position: relative;
  width: 50vw;
  min-width: 50vw;
  display: flex;
  justify-content: center;
  border: 2px solid black;
  border-radius: 15px;
  padding: 50px;
  border: 2px solid ${primary.main};
  background: ${background.gray3};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  & > * {
    color: ${primary.main};
  }

  @media (max-width: ${`${md}px`}) {
    width: 100%;
    max-width: calc(100% - 50px);
    margin: 0 auto;
    position: relative;
    padding: 35px 20px;
  }
`;

const offscreenSlideStyle = css`
  @media (max-width: ${`${md}px`}) {
    display: none;
  }
`;

const slideshowControlsWrapper = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
  display: flex;
  justify-content: space-between;

  & button.slide-control-left {
    box-shadow: inset 15vw 0 5vw -10vw #fff;
    justify-content: flex-start;
    pointer-events: all;
  }

  & button.slide-control-right {
    box-shadow: inset -15vw 0 5vw -10vw #fff;
    justify-content: flex-end;
    pointer-events: all;
  }

  @media (max-width: ${`${md}px`}) {
    display: none;
  }
`;

const slideshowControlButton = css`
  width: 25%;
  height: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 54px;
  animation: fade-in 0.5s ease;

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const slideshowControlButtonDisabled = css`
  width: 25%;
  height: 100%;
  border: none;
  background: transparent;
  cursor: default;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 54px;
  box-shadow: none !important;
`;

const arrowWrapper = css`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  box-shadow: ${shadows[1]};
`;

const newWrapper = css`
  display: flex;
`;

export {
  tallestStyle,
  slideshowWrapper,
  slideshowSlide,
  offscreenSlideStyle,
  slideshowControlsWrapper,
  slideshowControlButton,
  slideshowControlButtonDisabled,
  arrowWrapper,
  newWrapper,
};
